<p-toolbar [styleClass]="computedClass">
  <ng-template #start>
    <div class="flex items-center gap-3 max-md:w-full max-md:min-w-0">
      @if (icon) {
        <i [class]="icon + ' text-xl text-[var(--p-primary-color)]'" aria-hidden="true"></i>
      }

      <div class="grid gap-[0.15rem] max-md:min-w-0">
        @if (title) {
          <div class="m-0 !text-base font-bold leading-tight">{{ title }}</div>
        }
        @if (subtitle) {
          <div class="m-0 text-sm text-[var(--p-text-muted-color,var(--p-text-secondary-color))]">{{ subtitle }}</div>
        }
      </div>

      <ng-content select="[topbar-start]"></ng-content>
    </div>
  </ng-template>

  <ng-template #end>
    <div
      class="flex items-center gap-2 max-md:w-full max-md:flex-wrap max-md:justify-start [&>[topbar-actions]]:flex [&>[topbar-actions]]:items-center [&>[topbar-actions]]:gap-2 max-md:[&>[topbar-actions]]:w-full max-md:[&>[topbar-actions]]:flex-wrap max-md:[&>[topbar-actions]]:justify-start"
    >
      <ng-content select="[topbar-actions]"></ng-content>
    </div>
  </ng-template>
</p-toolbar>
